import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdOnboardingsOptions } from '@onefootprint/fetch-dashboard';
import { Select } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useEntityId from '@/entity/hooks/use-entity-id';
import DuplicateData from '../../../duplicate-data';
import { isAutomaticCheckOnboarding } from '../../../onboardings-shared/utils';
import Section from '../../../section';
import useOnboardingLabel from '../../use-onboarding-label';
const CURRENT = 'current';
const DuplicatesSection = () => {
  const $ = _c(21);
  const {
    t
  } = useTranslation("entity-details");
  const entityId = useEntityId();
  const onboardingLabel = useOnboardingLabel();
  let t0;
  if ($[0] !== entityId) {
    t0 = getEntitiesByFpIdOnboardingsOptions({
      path: {
        fpId: entityId
      },
      query: {
        pageSize: 100
      }
    });
    $[0] = entityId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: onboardingsPage
  } = useQuery(t0);
  const [selectedId, setSelectedId] = useState(CURRENT);
  let T0;
  let selectedOnboarding;
  let t1;
  let t2;
  if ($[2] !== onboardingLabel || $[3] !== onboardingsPage?.data || $[4] !== selectedId || $[5] !== t) {
    const onboardings = (onboardingsPage?.data ?? []).filter(_temp);
    let t3;
    if ($[10] !== selectedId) {
      t3 = onboarding_0 => onboarding_0.id === selectedId;
      $[10] = selectedId;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    selectedOnboarding = onboardings.find(t3);
    T0 = Section;
    if ($[12] !== t) {
      t1 = t(_temp2);
      $[12] = t;
      $[13] = t1;
    } else {
      t1 = $[13];
    }
    t2 = onboardings.length ? <Select aria-label={t(_temp3)} size="compact" value={selectedOnboarding?.id ?? CURRENT} onChange={setSelectedId} options={[{
      value: CURRENT,
      label: t(_temp4)
    }, ...onboardings.map(onboarding_1 => ({
      value: onboarding_1.id,
      label: onboardingLabel(onboarding_1)
    }))]} /> : null;
    $[2] = onboardingLabel;
    $[3] = onboardingsPage?.data;
    $[4] = selectedId;
    $[5] = t;
    $[6] = T0;
    $[7] = selectedOnboarding;
    $[8] = t1;
    $[9] = t2;
  } else {
    T0 = $[6];
    selectedOnboarding = $[7];
    t1 = $[8];
    t2 = $[9];
  }
  const t3 = selectedOnboarding?.completedAt;
  let t4;
  if ($[14] !== t3) {
    t4 = <DuplicateData timestamp={t3} />;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== T0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t4) {
    t5 = <T0 title={t1} suffixActions={t2}>{t4}</T0>;
    $[16] = T0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default DuplicatesSection;
function _temp(onboarding) {
  return onboarding.completedAt != null && !isAutomaticCheckOnboarding(onboarding);
}
function _temp2($) {
  return $.duplicateData.title;
}
function _temp3($_0) {
  return $_0.classicOnboardings.duplicatesAsOf;
}
function _temp4($_1) {
  return $_1.classicOnboardings.current;
}